import React from "react";
import { Progress } from "@/components/ui/progress";
import { Card, CardContent } from "@/components/ui/card";
import { Loader2 } from "lucide-react";

interface OrderProgressProps {
  isVisible: boolean;
  currentBatch: number;
  totalBatches: number;
  currentItem: number;
  totalItems: number;
  message: string;
}

const OrderProgress = ({
  isVisible,
  currentBatch,
  totalBatches,
  currentItem,
  totalItems,
  message,
}: OrderProgressProps) => {
  if (!isVisible) return null;

  const batchProgress =
    totalBatches > 0 ? (currentBatch / totalBatches) * 100 : 0;
  const itemProgress = totalItems > 0 ? (currentItem / totalItems) * 100 : 0;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <Card className="w-96 mx-4">
        <CardContent className="p-6 space-y-4">
          <div className="flex items-center gap-3">
            <Loader2 className="h-6 w-6 animate-spin text-primary" />
            <h3 className="text-lg font-semibold">Processando Pedido</h3>
          </div>

          <p className="text-sm text-muted-foreground">{message}</p>

          {totalBatches > 1 && (
            <div className="space-y-2">
              <div className="flex justify-between text-sm">
                <span>
                  Item {currentBatch} de {totalBatches}
                </span>
                <span>{Math.round(batchProgress)}%</span>
              </div>
              <Progress value={batchProgress} className="h-2" />
            </div>
          )}

          <div className="space-y-2">
            <div className="flex justify-between text-sm">
              <span>Itens processados</span>
              <span>
                {currentItem} / {totalItems}
              </span>
            </div>
            <Progress value={itemProgress} className="h-2" />
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default OrderProgress;
